/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_map_controls__aria_labels__compass = /** @type {(inputs: {}) => string} */ () => {
	return `Kompass`
};

const en_map_controls__aria_labels__compass = /** @type {(inputs: {}) => string} */ () => {
	return `Compass`
};

const es_map_controls__aria_labels__compass = /** @type {(inputs: {}) => string} */ () => {
	return `Brújula`
};

const fr_map_controls__aria_labels__compass = /** @type {(inputs: {}) => string} */ () => {
	return `Boussole`
};

const it_map_controls__aria_labels__compass = /** @type {(inputs: {}) => string} */ () => {
	return `Bussola`
};

const nl_map_controls__aria_labels__compass = /** @type {(inputs: {}) => string} */ () => {
	return `Kompas`
};

const pt_map_controls__aria_labels__compass = /** @type {(inputs: {}) => string} */ () => {
	return `Bússola`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__compass = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map_controls__aria_labels__compass(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map_controls__aria_labels__compass", locale)
	if (locale === "de") return de_map_controls__aria_labels__compass(inputs)
	if (locale === "en") return en_map_controls__aria_labels__compass(inputs)
	if (locale === "es") return es_map_controls__aria_labels__compass(inputs)
	if (locale === "fr") return fr_map_controls__aria_labels__compass(inputs)
	if (locale === "it") return it_map_controls__aria_labels__compass(inputs)
	if (locale === "nl") return nl_map_controls__aria_labels__compass(inputs)
	return pt_map_controls__aria_labels__compass(inputs)
};